import getEpisodeEditFormSchema from '@app/organisms/EpisodeEditForm/schemas/episodeEditFormSchema';

const getScheduleSchema = (intl) => {
    const baseSchema = getEpisodeEditFormSchema(intl);

    return baseSchema.clone();
};

export default getScheduleSchema;
